import React, {useEffect, useState} from 'react';
import {
  Grid,
  Button,
  Paper,
  Box,
  CircularProgress,
  TextField,
} from '@material-ui/core';
import {Form, Formik} from 'formik';
import {i18n2} from 'features/i18n/i18n';
import {MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {Trans} from '@lingui/macro';
import BarChartKPI from './../../../components/Graphics/Components/BarChartKPI';
import {Series} from 'devextreme-react/chart';
import KPIGrid from './grids/KPIGrid';
import getCourseTypes from './requests/getCourseTypes';
import {useUtilInformation} from 'components/hooks';
import getGraphicsKPI from './requests/kpi/getGraphicsKPI';
import {addFilter} from './helpers/createFilters';
import {ReportTypes} from 'helpers/report';
import PopupReport from 'components/Popups/PopupReport';
import {KPIReport} from 'constants/url';
import MultipleSelectAll from './form/multipleSelectAll';

const KPIForm = (props) => {
  const [isConsultReady, setIsConsultReady] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [typeCourse, setTypeCourse] = useState([]);
  const {token} = useUtilInformation();
  const [dataGraphics, setDataGraphics] = useState();
  const [filters, setFilters] = useState([]);
  const [openReport, setOpenReport] = useState(false);
  const [reportType, setReportType] = useState(null);
  const [values, setValues] = useState(null);

  useEffect(() => {
    getCourseTypes(token).then((data) => {
      if (data != null) {
        setTypeCourse(data);
      }
    });
  }, [token]);

  const handleSubmit = (values, formikBag, isPopup) => {
    var temporalFilters = [];
    Object.entries(values).map(([k, v]) => addFilter(k, v, temporalFilters));
    temporalFilters.push([['status', '=', 0], 'or', ['status', '=', 2]]);
    setFilters(temporalFilters);
    console.log(temporalFilters);
    if (isPopup) {
      setOpenReport(true);
      setValues(values);
    } else {
      setIsLoading(true);
      formikBag.setSubmitting(false);
      getGraphicsKPI(token, values).then((data) => {
        if (data != null) {
          setIsConsultReady(true);
          setDataGraphics(JSON.parse(data));
          setIsLoading(false);
        }
      });
    }
  };

  return (
    <>
      <Paper style={{margin: 10, marginTop: 0, padding: 10}}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Formik
            initialValues={{
              type: '',
              doc_Number: '',
            }}
            enableReinitialize
            onSubmit={(values, formikBag) => {
              handleSubmit(values, formikBag);
            }}>
            {({errors, touched, ...formikProps}) => {
              return (
                <Form>
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={6}>
                      <MultipleSelectAll
                        name="type"
                        label={i18n2._('Tipo')}
                        changeValue={(val) =>
                          formikProps.setFieldValue('type', val)
                        }
                        options={typeCourse}
                        customOptionLabel={(x) => `${x.name}`}
                        customOptionSelected={(option, value) => {
                          return option.iD_Type === value.iD_Type;
                        }}
                      />
                    </Grid>
                    <Grid item md={4} xs={6}>
                      <TextField
                        label={i18n2._('Documento')}
                        value={formikProps.values.doc_Number}
                        onChange={(e) =>
                          formikProps.setFieldValue(
                            'doc_Number',
                            e.target.value,
                          )
                        }
                        fullWidth
                        variant="outlined"
                      />
                    </Grid>
                    <Grid item md={8} xs={6}>
                      <Button
                        type="submit"
                        disabled={formikProps.isSubmitting}
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}>
                        <Trans>Visualizar</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.PDF);
                            }
                          })
                        }>
                        <Trans>Descargar PDF</Trans>
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        style={{margin: '5px'}}
                        onClick={(e) =>
                          formikProps.validateForm().then((errors) => {
                            if (
                              Object.keys(errors).length === 0 &&
                              errors.constructor === Object
                            ) {
                              handleSubmit(
                                formikProps.values,
                                formikProps.formikBag,
                                true,
                              );
                              setReportType(ReportTypes.Excel);
                            }
                          })
                        }>
                        <Trans>Descargar excel</Trans>
                      </Button>
                    </Grid>
                  </Grid>
                </Form>
              );
            }}
          </Formik>
        </MuiPickersUtilsProvider>
        <PopupReport
          open={openReport}
          setOpen={setOpenReport}
          name="Reporte de KPI"
          url={KPIReport}
          pdfOnly={false}
          type={reportType}
          userFilters={values}
          filters={filters}
        />
      </Paper>
      {isLoading ? (
        <Grid
          container
          alignContent="center"
          alignItems="center"
          justify="center">
          <Box style={{margin: 50, padding: 50}}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : isConsultReady ? (
        <>
          <Paper style={{margin: 10, padding: 10}}>
            <BarChartKPI dataSource={dataGraphics}>
              <Series valueField="onTime" />
              <Series valueField="nearDueDate" />
              <Series valueField="almostDueDate" />
              <Series valueField="dued" />
            </BarChartKPI>
          </Paper>
          <Paper style={{margin: 10, padding: 10}}>
            <KPIGrid filters={filters} pendingOnly isKPIView />
          </Paper>
        </>
      ) : null}
    </>
  );
};

export default KPIForm;
